import { isValidEntityType } from "types";
import { ENTITY_TYPE_PARAMETER } from "helpers/constants/miscellaneous";
import useAllQueryParamsFilters from "./useAllQueryParamsFilters";

const useEntityTypeFromQuery = () => {
  const queryParamsFilters = useAllQueryParamsFilters();
  const entityType = queryParamsFilters[ENTITY_TYPE_PARAMETER];

  return isValidEntityType(entityType) ? entityType : null;
};

export default useEntityTypeFromQuery;
